import { DisplayObject  } from "pixi.js";
import dragonBones from "pixi5-dragonbones";
import App from "../App";

import BaseView from "./BaseView";

class DragonBones {
    private readonly pixiArmatureDisplay: dragonBones.PixiArmatureDisplay;

    constructor(skeletonData: any, spriteSheet: any, spriteSheetImage: any, armatureName: string, armatureKey: string) {
        // We can't use the dragonBones namespace here, because of the unit tests
        const db = require("pixi5-dragonbones");
        const factory = db.PixiFactory.factory;
        
        factory.parseDragonBonesData(skeletonData, armatureKey);
        factory.parseTextureAtlasData(spriteSheet, spriteSheetImage, armatureKey);
        this.pixiArmatureDisplay = factory.buildArmatureDisplay(armatureName, armatureKey, armatureKey);
        this.pixiArmatureDisplay.animation.timeScale = App.instance.timeScale;
    }

    public get armatureDisplay(): dragonBones.PixiArmatureDisplay {
        return this.pixiArmatureDisplay;
    }
}

export default class DragonBonesAnimation {
    public static names: string[] = [];
    private db: DragonBones;

    constructor(armatureName: string, skeletonData, spriteSheet, spriteSheetImage) {
        let armatureKey = armatureName;
        let counter = 0;

        while(DragonBonesAnimation.names.includes(armatureKey)) {
            armatureKey = armatureName + "~" + counter;
            counter++;
        }

        DragonBonesAnimation.names.push(armatureKey);
        this.db = new DragonBones(skeletonData, spriteSheet, spriteSheetImage, armatureName, armatureKey);
    }

    public getArmatureDisplay(): dragonBones.PixiArmatureDisplay {
        return this.db.armatureDisplay;
    }
    
    public get animationNames(): readonly string[] {
        return this.db.armatureDisplay.animation.animationNames;
    }

    public get armatureName(): string {
        return this.db.armatureDisplay.armature.name
    }
    
    public get displayObject(): DisplayObject {
        return <DisplayObject><unknown>this.db.armatureDisplay;
    }
    
    public hasAnimation(animationName: string): boolean {
        return this.db.armatureDisplay.animation.hasAnimation(animationName);
    }

    public play(animationName?: string, count?: number): Promise<boolean> {
        return new Promise((res) => {
            this.db.armatureDisplay.animation.play(animationName, count);
            let animComplete;
            animComplete = ()=>{
                res();
            }

            // We can't use the dragonBones namespace here, because of the unit tests
            const db = require("pixi5-dragonbones");
            this.displayObject.once(db.EventObject.LOOP_COMPLETE, animComplete, this);
            this.displayObject.once(db.EventObject.COMPLETE, animComplete, this);
        });
    }
    
    public goToAndStop(animationName?: string): void {
        this.db.armatureDisplay.animation.gotoAndPlayByProgress(animationName, 1,1);
    }

    public goToAndPlay(animationName?: string): void {
        this.db.armatureDisplay.animation.gotoAndPlayByProgress(animationName, 2.5);
    }

    public stop(animationName?: string): void {
        this.db.armatureDisplay.animation.stop(animationName);
    }

    public stopOnComplete(hideOnComplete = true): void {
        // this.armatureDisplay.once(db.EventObject.COMPLETE, () => {
        //     this.armatureDisplay.removeAllListeners();
        //     this.stop()
        // }, this);
        
        // We can't use the dragonBones namespace here, because of the unit tests
        const db = require("pixi5-dragonbones");
        this.displayObject.once(db.EventObject.LOOP_COMPLETE, () => {
            this.displayObject.removeAllListeners();
            this.stop();
            this.displayObject.visible = !hideOnComplete;
        }, this);
    }

    public destroy(): void {
        this.db.armatureDisplay.animation.stop();
        this.displayObject.parent.removeChild(this.displayObject);
        this.db.armatureDisplay.destroy();
        this.db = null;
    }
}